<div class="flex h-screen">
  <!-- Sidebar -->
  <div class="w-64 bg-gray-800 text-white shadow-lg">
    <div class="p-6">
      <h1 class="text-2xl font-bold text-white mb-8">Fleet Manage</h1>
      
      <nav class="space-y-2">
        <a 
          routerLink="/vehicles" 
          routerLinkActive="bg-blue-600"
          class="flex items-center px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-lg transition-colors">
          <i class="pi pi-car mr-3"></i>
          <span>Veículos</span>
        </a>
        
        <a 
          routerLink="/users" 
          routerLinkActive="bg-blue-600"
          class="flex items-center px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-lg transition-colors">
          <i class="pi pi-users mr-3"></i>
          <span>Usuários</span>
        </a>

        <a 
          routerLink="/customers" 
          routerLinkActive="bg-blue-600"
          class="flex items-center px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-lg transition-colors">
          <i class="pi pi-user mr-3"></i>
          <span>Clientes</span>
        </a>
        
        <a 
          routerLink="/rides" 
          routerLinkActive="bg-blue-600"
          class="flex items-center px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-lg transition-colors">
          <i class="pi pi-map mr-3"></i>
          <span>Corridas</span>
        </a>
      </nav>
      
      <!-- Botão de Sair -->
      <div class="mt-8 pt-4 border-t border-gray-700">
        <button 
          (click)="logout()"
          class="flex items-center w-full px-4 py-3 text-gray-300 hover:bg-red-600 hover:text-white rounded-lg transition-colors">
          <i class="pi pi-sign-out mr-3"></i>
          <span>Sair</span>
        </button>
      </div>
    </div>
  </div>
  
  <!-- Main Content -->
  <div class="flex-1 overflow-auto bg-gray-50">
    <router-outlet />
  </div>
</div>

<p-confirmDialog />